export default {
    api: {
        healthCheck: {
            uri: '/api/healthcheck',
            method: 'GET',
        },
        getAccount: {
            uri: '/api/account/get',
            method: 'GET',
        },
        login: {
            uri: '/api/account/authorize',
            method: 'POST',
        },
        logout: {
            uri: '/api/account/deauthorize',
            method: 'GET',
        },
        register: {
            uri: '/api/account/register',
            method: 'POST',
        },
        checkActiveAccount: {
            uri: '/api/account/check_active_account',
            method: 'POST',
        },
        gdprSet: {
            uri: '/api/account/gdpr-set',
            method: 'POST',
        },
        createToken: {
            uri: '/api/token/create',
            method: 'POST',
        },
        getToken: {
            uri: '/api/token/info',
            method: 'GET',
        },
        refreshToken: {
            uri: '/api/token/refresh',
        },

        changePassword: {
            uri: '/api/account/change-password',
            method: 'POST',
        },
        forgottenPassword: {
            uri: '/api/account/forgotten-password-prepare',
            method: 'POST',
        },
        changeForgottenPassword: {
            uri: '/api/account/forgotten-password-finish',
            method: 'POST',
        },
        ordersGet: {
            uri: '/api/account/orders',
            method: 'POST',
        },
        bookingsGet: {
            uri: '/api/account/bookings',
            method: 'POST',
        },
        uploadProfileImage: {
            uri: '/api/account/profile-picture',
            method: 'POST',
        },

        loyaltyProgramRegister: {
            uri: '/api/loyalty-program/register',
            method: 'POST',
        },
        loyaltyProgramBlock: {
            uri: '/api/loyalty-program/block',
            method: 'GET',
        },
        loyaltyProgramCoupons: {
            uri: '/api/loyalty-program/vouchers',
            method: 'GET',
        },
        loyaltyProgramRewards: {
            uri: '/api/loyalty-program/rewards',
            method: 'POST',
        },
        loyaltyProgramTransactions: {
            uri: '/api/loyalty-program/transactions',
            method: 'GET',
        },
        getEventData: {
            uri: '/api/event/get',
            method: 'POST',
        },
        getRelatedEvents: {
            uri: '/api/event/related-events',
            method: 'POST',
        },
        getHallData: {
            uri: '/api/hall/get',
            method: 'POST',
        },

        //CART
        getBasketData: {
            uri: '/api/cart/get',
            method: 'POST',
        },
        getVouchers: {
            uri: '/api/cart/vouchers',
            method: 'POST',
        },
        setVouchers: {
            uri: '/api/cart/voucher-set',
            method: 'POST',
        },
        cardProlonge: {
            uri: '/api/cart/card-prolonge',
            method: 'POST',
        },
        cardRemove: {
            uri: '/api/cart/card-remove',
            method: 'DELETE',
        },
        addTicketsToBasket: {
            uri: '/api/cart/ticket-add',
            method: 'POST',
        },
        removeTicketFromBasket: {
            uri: '/api/cart/ticket-remove',
            method: 'DELETE',
        },
        changeTicketCategory: {
            uri: '/api/cart/ticket-change-category',
            method: 'POST',
        },
        ticketPointPayment: {
            uri: '/api/cart/ticket-pay-by-points',
            method: 'POST',
        },
        ticketMoneyPayment: {
            uri: '/api/cart/ticket-pay-by-money',
            method: 'POST',
        },
        setPayment: {
            uri: '/api/cart/set-payment',
            method: 'POST',
        },
        cartRelease: {
            uri: '/api/cart/release',
            method: 'POST',
        },
        ticketVoucherAdd: {
            uri: '/api/cart/ticket-voucher-add',
            method: 'POST',
        },
        ticketVoucherRemove: {
            uri: '/api/cart/ticket-voucher-remove',
            method: 'POST',
        },

        //BOOKING
        bookingCreate: {
            uri: '/api/booking/create',
            method: 'POST',
        },
        bookingGet: {
            uri: '/api/booking/get',
            method: 'POST',
        },
        bookingCancel: {
            uri: '/api/booking/cancel',
            method: 'POST',
        },

        bookingRestoreToCard: {
            uri: '/api/booking/restore-to-cart',
            method: 'POST',
        },

        //SMS
        sendSms: {
            uri: '/api/sms/send',
            method: 'POST',
        },

        //ORDER
        orderGet: {
            uri: '/api/order/get',
            method: 'POST',
        },
        paymentCreate: {
            uri: '/api/payment/create',
            method: 'POST',
        },
        paymentCancel: {
            uri: '/api/payment/cancel-online',
            method: 'DELETE',
        },

        paymentVerify: {
            uri: '/api/payment/verify',
            method: 'POST',
        },
        eticketGet: {
            uri: '/api/document/eticket',
            method: 'POST',
        },
        evoucherGet: {
            uri: '/api/document/evoucher',
            method: 'POST',
        },
    },
    mailSender: {
        mailTemplate: {
            uri: '/api/mail/publish',
        },
        forgottenPassword: {
            uri: '/api/mail/publish',
        },
    },
    cinestarGql: {
        getGqlEventData: {
            method: 'POST',
            uri: '/api',
        },
    },
}
